//import styles from './Layout.module.css';
import React from 'react'
import { useState } from 'react'
import { Link } from 'gatsby'
import { Dialog, DialogPanel } from '@headlessui/react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
import TerminalPrompt from '../TerminalPrompt/TerminalPrompt'
import AnimatedGlitch from '../AnimatedGlitch/AnimatedGlitch'

const navigation = [
  { name: 'Work', href: '/work' },
  { name: 'About', href: '/about' },
  { name: 'Blog', href: '/blog' }
];

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 header mix-blend-exclusion">
      {/* Animated Glitch Effect on left edge - lime green theme */}
      <div className="absolute left-[-2.25rem] top-[-1.25rem] -z-10 pointer-events-none mix-blend-normal">
        <AnimatedGlitch
          width={120}
          height={120}
          cellSize={12}
          speed={300}
          speedVariance={0.4}
          density={0.55}
          persistence={0.55}
          primaryColor="#a3e635"
          secondaryColor="#03111F"
          tertiaryColor="#bef264"
          quaternaryColor="#03111F"
        />
      </div>
      <nav className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8" aria-label="Global">
        <Link to="/" className="-m-1.5 p-1.5">
          <TerminalPrompt />
        </Link>
        <div className="flex lg:hidden">
          <button
            type="button"
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-white"
            onClick={() => setMobileMenuOpen(true)}
          >
            <span className="sr-only">Open main menu</span>
            <Bars3Icon className="h-6 w-6" aria-hidden="true" />
          </button>
        </div>
        <div className="hidden lg:flex lg:gap-x-12">
          {navigation.map((item) => (
            <Link key={item.name} to={item.href} className="text-sm font-semibold uppercase tracking-wider leading-6 text-white hover:text-lime-400">
              {item.name}
            </Link>
          ))}
        </div>
      </nav>
      <Dialog as="div" className="lg:hidden" open={mobileMenuOpen} onClose={setMobileMenuOpen}>
        <div className="fixed inset-0 z-10" />
        <DialogPanel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-[#03101f] px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
          {/* Animated Glitch Effect on left edge - lime green theme */}
          <div className="absolute left-[-2.25rem] top-[-1.25rem] -z-10 pointer-events-none mix-blend-normal">
            <AnimatedGlitch
              width={120}
              height={120}
              cellSize={12}
              speed={300}
              speedVariance={0.4}
              density={0.45}
              persistence={0.65}
              primaryColor="#a3e635"
              secondaryColor="#041220"
              tertiaryColor="#bef264"
              quaternaryColor="#03111F"
            />
          </div>
          <div className="flex items-center justify-between">
            <Link to="/" className="-m-1.5 p-1.5">
              <TerminalPrompt />
            </Link>
            <button
              type="button"
              className="-m-2.5 rounded-md p-2.5 text-white"
              onClick={() => setMobileMenuOpen(false)}
            >
              <span className="sr-only">Close menu</span>
              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <div className="mt-6 flow-root">
            <div className="-my-6 divide-y divide-gray-500/10">
              <div className="space-y-2 py-6">
                {navigation.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold uppercase leading-7 text-white hover:bg-lime-400 hover:text-black"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    {item.name}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </DialogPanel>
      </Dialog>
    </header>
  );
}
